import { engineComponent } from "neo-common";
import { WinAnimator2 } from "./WinAnimator2";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Tweens } from "../Components/Effects/Tweens";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { Symbol } from "../GameComponents/Symbol";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { ModuleManager } from "../Managers/ModuleManager";
import { Communication } from "neo-games";
import { CustomUtils } from "../Utils/CustomUtils";
import { GameManager } from "../Managers/GameManager";
import { MachineExtended } from "./MachineExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator3 extends WinAnimator2 {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected idleReelsTimer: FrameTimerEventEmitter;

    protected background: SwitchElement;

    protected currentSymbolsMachine: Array<Array<Symbol>>;

    protected isFirstIdle: boolean = true;

    protected multipliersHolder: SwitchElement;

    //******************************************************************************************************************
    //  CREATE, INITIALIZE
    //******************************************************************************************************************

    constructor() {
        super();

        this.idleReelsTimer = CreateFrameTimer("idleReelsTimer");
        this.idleReelsTimer.on(FrameTimerEvents.Complete, this.idleReels.bind(this));
    }

    public preInitialize(background: SwitchElement): void {
        this.background = background;
    }

    public initializeMultipliers(multipliersHolder: SwitchElement): void {
        this.multipliersHolder = multipliersHolder;
    }

    //******************************************************************************************************************
    //  ON REEL STOPPED, SHOW SYMBOLS
    //******************************************************************************************************************

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        this.updateMultipliersOnReelStop(reelsData, reelIndex);
    }

    //******************************************************************************************************************
    //  MULTIPLIERS
    //******************************************************************************************************************

    private updateMultipliersOnReelStop(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        const count = this.getWildsCount(reelsData, reelIndex);
        if (!MachineExtended.Force) {
            this.multipliersHolder.goToCase("TEASING_X" + (count + 1));
        } else {
            this.multipliersHolder.goToCase("NORMAL");
        }
    }

    private showMultiplierWin(): void {
        const count = this.getWildsCount(this.currentReels);

        if (count > 0) {
            this.multipliersHolder.goToCase("TEASING_X" + GameManager.baseResponse.gameMultiplier + "_WIN");
        }
    }

    private cycleMultiplierWin(): void {
        const count = this.getWildsCount(this.currentReels);

        if (count > 0) {
            this.multipliersHolder.goToCase("TEASING_X" + GameManager.baseResponse.gameMultiplier + "_POP");
        }
    }

    private resetMultiplierWin(): void {
        this.multipliersHolder.goToCase("NORMAL");
    }

    private getWildsCount(reelsData: Array<Communication.Game.IReel>, reelIndex: number = -1): number {
        const reelCount = reelIndex == -1 ? this.reelCount : reelIndex + 1;
        let count = 0;

        for (let i = 0; i < reelCount; i++) {
            if (reelsData[i].symbols.indexOf(CustomUtils.SymbolWild) > -1) {
                count++;
            }
        }

        return count;
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    protected showCustomWin(): boolean {
        if (this.background.getCurrentCase() !== "SHOW_WIN") {
            this.background.goToCase("SHOW_WIN");
        }

        this.showMultiplierWin();

        return false;
    }

    //******************************************************************************************************************
    //  SHOW INIT WINS
    //******************************************************************************************************************

    protected showCustomInitWin(): void {
        if (this.background.getCurrentCase() !== "SHOW_WIN") {
            this.background.goToCase("SHOW_WIN");
        }

        this.showMultiplierWin();
    }

    //******************************************************************************************************************
    //  CYCLE WINS
    //******************************************************************************************************************

    protected cycleWins(): void {
        if (this.currentWins == null) {
            return;
        }

        this.cycleMultiplierWin();

        super.cycleWins();
    }

    //******************************************************************************************************************
    //  RESET
    //******************************************************************************************************************

    public reset(showLastSymbols: boolean, spin = false): boolean {
        if (!ModuleManager.gambleActive()) {
            if (this.background.getCurrentCase() === "SHOW_WIN" || this.background.getCurrentCase() === "WIN") {
                this.background.goToCase("HIDE_WIN");
            }
        }

        this.resetMultiplierWin();

        // this.reels.reelGlowLeft.goToCase('END');
        // this.reels.reelGlowCenter.goToCase('END');
        // this.reels.reelGlowRight.goToCase('END');
        // this.reels.separatorLeftEdge.goToCase('END');
        // this.reels.separatorRight.goToCase('END');
        // this.reels.separatorLeft.goToCase('END');
        // this.reels.separatorRightEdge.goToCase('END');
        // }

        if (spin) {
            // this.reels.reelGlowLeft.goToCase('END');
            // this.reels.reelGlowCenter.goToCase('END');
            // this.reels.reelGlowRight.goToCase('END');
            // this.reels.separatorLeftEdge.goToCase('END');
            // this.reels.separatorRight.goToCase('END');
            // this.reels.separatorLeft.goToCase('END');
            // this.reels.separatorRightEdge.goToCase('END');

            this.idleReelsTimer.stop();
            this.isFirstIdle = true;
        }

        this.currentSymbolsMachine = this.currentSymbols;

        return super.reset(showLastSymbols, spin);
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        super.addCurrentSymbol(reelIndex, symbolIndex);

        // if (this.currentSymbols[reelIndex][symbolIndex].id === 9) {
        //     (<any> this.currentSymbols[reelIndex][symbolIndex]).elements.childs['Bird'].animate([{name: 'Animation', loop: true}]);
        // }
    }

    protected winSymbolsGoToCase(winIndex: number, caseType: string, useValue: boolean): Array<Symbol> {
        const symbols = super.winSymbolsGoToCase(winIndex, caseType, useValue);

        if (this.value.visible) {
            const win = this.currentWins[winIndex];

            if (win.paylineId > 27) {
                this.value.position.x = symbols[symbols.length - 1].position.x + symbols[symbols.length - 1].offsetX;
                this.value.position.y = symbols[symbols.length - 1].position.y + symbols[symbols.length - 1].offsetY;
            }
        }

        return symbols;
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];
                    symbol.goToCase(caseType);

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    /**
     *
     * @param reelIndex
     * @param symbolIndex
     * @param caseType
     */
    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        const symbol = this.currentSymbols[reelIndex][symbolIndex];

        if (symbol.getCurrentCase() === Symbol.CaseIdle && caseType === Symbol.CaseNormal) {
            return false;
        }

        return true;
    }

    //******************************************************************************************************************
    //  ANIMATIONS
    //******************************************************************************************************************

    protected startAnimation(): void {
        // this.reels.reelGlowLeft.goToCase('END');
        // this.reels.reelGlowCenter.goToCase('END');
        // this.reels.reelGlowRight.goToCase('END');
        // this.reels.separatorLeftEdge.goToCase('END');
        // this.reels.separatorRight.goToCase('END');
        // this.reels.separatorLeft.goToCase('END');
        // this.reels.separatorRightEdge.goToCase('END');

        super.startAnimation();
    }

    protected onAnimationFinished(): void {
        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseToCycle, false);
        }

        // this.reels.reelGlowLeft.goToCase('END');
        // this.reels.reelGlowCenter.goToCase('END');
        // this.reels.reelGlowRight.goToCase('END');
        // this.reels.separatorLeftEdge.goToCase('END');
        // this.reels.separatorRight.goToCase('END');
        // this.reels.separatorLeft.goToCase('END');
        // this.reels.separatorRightEdge.goToCase('END');

        super.onAnimationFinished();
    }

    //******************************************************************************************************************
    //  COUNTER
    //******************************************************************************************************************

    protected createCounter(): void {
        super.createCounter();

        this.counter.addChildAt(this.childs["CounterFlare"], 0);
    }

    protected runCounterStep1(): void {
        const win = this.currentWins[this.currentCounterStep];
        (<any>this.counter.getChildByName("CounterFlare")).goToCase("STEP_1");

        super.runCounterStep1();
    }

    protected runCounterStep2(): void {
        (<any>this.counter.getChildByName("CounterFlare")).goToCase("STEP_2");

        super.runCounterStep2();
    }

    protected runCounterStep3(): void {
        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseToCycle, false);
        }
        (<any>this.counter.getChildByName("CounterFlare")).goToCase("STEP_3");

        super.runCounterStep3();
    }

    protected runCounterOutro(): void {
        (<any>this.counter.getChildByName("CounterFlare")).goToCase("OUTRO");

        super.runCounterOutro();
    }

    getCurrentSymbols(index: number): Array<Symbol> {
        for (let i = 0; i < this.currentSymbolsMachine[index].length; i++) {
            // if(this.currentSymbolsMachine[index][i].id==10){
            //     let symbol:Symbol = this.currentSymbolsMachine[index][i];
            //     this.currentSymbolsMachine[index][i] = symbol;
            // }
        }
        return this.currentSymbolsMachine[index];
    }

    protected idleReels(): void {
        this.idleReelsTimer.stop();

        this.idleReelsTimer.start(360);
    }

    protected idle(): void {
        if (this.isFirstIdle) {
            this.isFirstIdle = false;
            this.idleReels();
        }

        super.idle();
    }

    protected getIdleDelay(): number {
        return 120;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator3.ts
 **/